/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { PjInjectProxy } from '../../extends_fw/PjInjectProxy';
import { PjBaseController } from '../../extends_fw/controller/PjBaseController';
import { PjServiceResponse } from '../../extends_fw/service/PjServiceResponse';

/**
 * システムエラー画面を表示する。
 */
export class SystemErrorController extends PjBaseController {

    /**
     * エラーコード
     */
    public code: string;

    /**
     * エラーメッセージ
     */
    public msg: string;

    /**
     * コンストラクタ
     * @param {angular.ui.IStateParamsService} $stateParams 画面間の引き継ぎデータ
     * @param {ng.translate.ITranslateService} $translate angular-translateのサービス
     * @param {PjInjectProxy} pjInjectProxy インジェクタプロキシ
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy) {
        super($stateParams, $translate, pjInjectProxy);

        this.setTitle('システムエラー');

        // エラーコードとメッセージを設定
        this.code = $stateParams['code'];
        this.$translate(this.code, null, null, null, 'ja').then((message: string) => {
            this.msg = message;
        });
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(
            data: any): void {
    }

    /**
     * 表示処理
     */
    public show(): void {
    }

}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/error/controller/SystemErrorController.ts
 **/